import { useCallback } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import {
  useGetPaymentTransactions,
  getGetPaymentTransactionsQueryKey,
} from '@/types/origin-point-engine'
import { useAuthStore } from '@/features/auth'

export const useTransactions = (params?: { page?: number; limit?: number }) => {
  const { user } = useAuthStore((s) => s.auth)
  const queryClient = useQueryClient()

  const transactionsQuery = useGetPaymentTransactions(params, {
    query: {
      enabled: !!user && !!params,
      staleTime: 1000 * 60,
    },
  })

  const invalidateTransactions = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: getGetPaymentTransactionsQueryKey(),
      refetchType: 'all', // 确保即使是不活跃的查询（弹窗关闭时）也会在后台重新获取
    })
  }, [queryClient])

  return {
    transactionsQuery,
    invalidateTransactions,
  }
}
